import { PencilFill } from "react-bootstrap-icons";

//App
import Button from "../VFX-UI/Button/Button";
import { EditButtonProps } from "../../../types";
import useButtonStyles from "./styles";

const EditButton = (props: EditButtonProps) => {
  const { editActionHandler, text = false } = props;
  const buttonsStyles = useButtonStyles();
  const edit = text ? "Edit" : "";
  return (
      <Button style={buttonsStyles.editButton} onClick={editActionHandler}>
      <PencilFill />
      {edit}
    </Button>
  );
};

export default EditButton;
